import axios from "axios";
import { FileStorageDefaultApiResponse, FileStorageS10Data, FileStorageUploadPresignedUrlResponse, PresignedUrlData, PresignedUrlRequest } from "../interfaces/fileStorage.interface";
import { store } from "../store";


// const S10_URL = process.env.REACT_APP_MODULES_S10_API;
const fileStorageApiRequest = axios.create({
    baseURL: `${process.env.REACT_APP_FILESTORAGE_API}`,
    // baseURL: 'https://s10cloud.com:50023/FileStorage/api',
	headers: {
		'x-api-key': process.env.REACT_APP_FILE_STORAGE_API_KEY,
		AccessType: 1,
		moduleId: process.env.REACT_APP_MODULE_ID,
	}
})


export const getPresignedUrlRequest = async (token: string, numberFS: string) => {
	const headers = {
		token,
		AccessType: 1,
		'x-api-key': undefined,
	};
	const result = await fileStorageApiRequest.get( 
		// `/FileStorage/api/FileStorageApi/DownloadSignedById?id=${numberFS}`,
		`/FileStorageApi/DownloadSignedById?id=${numberFS}`,
		{headers}
	)
		.then(r => r)
		.catch(e => e);
	return result
}

interface FileInterface {
	Key: string;
	FileName?: string;
}

export const signedDownloadUrl = async (ruc: string, files: FileInterface[]) => {
    const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessType: 1,
	}
	const body = {
		"ruc": ruc,
		"Keys": files
	};
	
	const result = await fileStorageApiRequest.post( 
		"FileStorageApi/DownloadByKeys",
		body,
		{headers}
	);
	console.log(result);
	return result.data
}

export const signedUploadUrl = async (data: PresignedUrlRequest): Promise<FileStorageUploadPresignedUrlResponse | null> => {
    const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessType: 1,
	}
	const result = await fileStorageApiRequest.post( 
			"/FileStorageApi/UploadFileRequest",
			data,
			{headers}
		).then(r => r.data as FileStorageUploadPresignedUrlResponse)
		.catch(e => {
			console.error(e);
			return null;
		});
	return result
}


export const uploadFileToS3 = async (file: File, preSignedUrl: PresignedUrlData): Promise<boolean> => {
	const formData = new FormData();
	const presignedData = preSignedUrl.fields as any
	for (let key in presignedData) {
		const value = presignedData[key];
		formData.append(key, value);
	  }
	formData.append('file', file);
	const response = await axios.post(preSignedUrl.url, formData);
	if (response.status >= 200 && response.status < 300) {
	  return true;
	} else {
	  console.error('Failed to upload file:');
	  console.log(response);
	  return false;
	}
};


export const addOrUpdateGroupId = async (data: FileStorageS10Data[]): Promise<FileStorageDefaultApiResponse | null> => {
    const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessType: 1,
	}
	const result = await fileStorageApiRequest.post( 
			"/FileStorageApi/AddOrUpdateRangeToStorage",
			{Values: data},
			{headers}
		).then(r => r.data as FileStorageDefaultApiResponse)
		.catch(e => {
			console.error(e);
			return null;
		});
	return result
}


export const deleteGroupIdRequest = async (groupId: string): Promise<FileStorageDefaultApiResponse | null> => {
    const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessType: 1,
	}
	const result = await fileStorageApiRequest.get( 
			`/DocumentStorageApi/DeleteByGroup?group=${groupId}`,
			{headers}
		).then(r => {
			console.log("file deleted")
			console.log(r.data)
			return r.data as FileStorageDefaultApiResponse
		})
		.catch(e => {
			console.error(e);
			return null;
		});
	return result
}

export const getListOfFiles = async (groupId: string): Promise<FileStorageS10Data[] | null> => {
    const {companyselected} = store.getState().auth;
	const headers = {
		token: companyselected?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessType: 1,
	}
	const result = await fileStorageApiRequest.get( 
			`/DocumentStorageApi/ToListByGroupList?group=${groupId}`, // companyselected?.Code
			{headers}
		).then(r => {
			return r.data as FileStorageS10Data[]
		})
		.catch(e => {
			console.error(e);
			return null;
		});
	return result
}

export const deleteDocumentRequest = async (documentId: string): Promise<FileStorageDefaultApiResponse | null> => {
    const authCompanySelectedState = store.getState().auth.companyselected;
	const headers = {
		token: authCompanySelectedState?.Token,
		ModuleId: process.env.REACT_APP_MODULE_ID,
		AccessType: 1,
	}
	const result = await fileStorageApiRequest.get( 
			`/FileStorageApi/DeleteDocumentStorage?id=${documentId}`,
			{headers}
		).then(r => {
			if (r?.data?.Type === 0) {
				return r.data as FileStorageDefaultApiResponse
			}
			console.log("file deleted")
			console.log(r.data)
			return null
		})
		.catch(e => {
			console.error(e);
			return null;
		});
	return result
}